import { render, staticRenderFns } from "./getJlPopu.vue?vue&type=template&id=29a4779a&"
import script from "./getJlPopu.vue?vue&type=script&lang=js&"
export * from "./getJlPopu.vue?vue&type=script&lang=js&"
import style0 from "./getJlPopu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports